import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Wagholitomumbaicab() {



  const cardData =
  {
    keyword: ' Wagholi to Mumbai Cab',
    heading: 'Sai Trupti Cabs: Wagholi to Mumbai Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Wagholi to Mumbai cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Wagholi, courteous service, and safe, smooth driving all the way to Mumbai. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Wagholi to Mumbai convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, overlooking the vast Arabian Sea, is Mumbai’s most iconic monument and a timeless symbol of the city’s colonial heritage. Built in 1924 to commemorate the visit of King George V and Queen Mary, the grand basalt arch reflects Indo-Saracenic architecture at its finest. Tourists gather here to watch ferries depart for Elephanta Caves or simply to enjoy the sea breeze and panoramic views. The monument glows beautifully at dusk as pigeons flutter above and street vendors add to the city’s rhythm. Standing before the Gateway feels like witnessing Mumbai’s enduring spirit — proud, welcoming, and eternally vibrant."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a sweeping boulevard curving gracefully along the Arabian Sea. Its string of streetlights forms a dazzling necklace when viewed at night. Locals and travelers alike come here to walk, jog, or sit by the promenade, watching waves crash against the sea wall. The cool breeze, skyline views, and calm rhythm make it one of Mumbai’s most peaceful spots. At sunset, the horizon glows orange while couples, families, and friends gather to unwind. Marine Drive captures the soul of Mumbai — fast-paced yet full of quiet beauty."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "Chhatrapati Shivaji Maharaj Terminus, formerly known as Victoria Terminus, is a UNESCO World Heritage Site and a masterpiece of Victorian Gothic architecture. Completed in 1887, this bustling railway terminus blends domes, turrets, stained glass, and intricate stone carvings into one majestic design. Inside, travelers and daily commuters move in a rhythm that mirrors Mumbai’s pulse. Despite being a transit hub, CSMT feels like a cathedral of movement and history. At night, its façade lights up in dazzling colors, turning a functioning station into a living monument of Mumbai’s heritage and modern energy."
  },
  {
    "title": "Elephanta Caves",
    "description": "A short ferry ride from the Gateway of India takes visitors to the Elephanta Caves, a UNESCO World Heritage Site carved out of solid basalt rock. Dating back to the 5th–7th centuries, these caves are dedicated to Lord Shiva and house magnificent sculptures, the most famous being the three-headed Trimurti symbolizing creation, preservation, and destruction. The island’s quiet pathways, stone carvings, and ocean views create a mystical atmosphere. Exploring the caves feels like stepping into India’s ancient past, far removed from the noise of the modern city. Elephanta stands as a sacred echo of Mumbai’s deep spiritual roots."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach, stretching along Mumbai’s western coast, is a vibrant gathering spot for locals and tourists. Known for its golden sands and lively evenings, it’s the perfect place to enjoy the sea breeze and Mumbai’s famous street food — pav bhaji, bhel puri, and gola. Children play cricket on the sands while couples walk by the waves as planes soar overhead from the nearby airport. During sunset, the beach glows in hues of orange and gold, creating postcard-perfect moments. Juhu Beach captures Mumbai’s coastal charm — simple, joyful, and full of life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, sits serenely on an islet off Worli Coast and is accessible only during low tide via a narrow causeway. The white marble mosque and tomb dedicated to the Sufi saint Pir Haji Ali Shah Bukhari attract devotees of all faiths. The rhythmic sound of waves, soft prayers, and sea breeze create an atmosphere of peace and unity. As tides rise, the shrine appears to float on the water — a mesmerizing sight. Haji Ali is more than a religious monument; it’s a beacon of Mumbai’s inclusive and spiritual heart."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is a modern engineering marvel that defines Mumbai’s skyline. This 5.6-km cable-stayed bridge connects South Mumbai to the western suburbs, dramatically reducing travel time while offering breathtaking views of the sea and city. Driving across it, especially at night when it’s illuminated, feels like gliding above the ocean. The Sea Link represents Mumbai’s forward momentum — a bridge between history and progress. Its sleek design and symbolic presence make it not just infrastructure but a monument to the city’s ambition and resilience."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park, one of the world’s few national parks located within a metropolis, spreads over 100 square kilometers of lush greenery. It offers nature trails, boating, and wildlife encounters, providing a refreshing contrast to Mumbai’s concrete jungle. Within the park lie the ancient Kanheri Caves — rock-cut Buddhist monasteries dating back to the 1st century BCE. Visitors can trek through forest paths, explore the caves’ carvings, and enjoy panoramic hilltop views. The park is Mumbai’s natural lung — a sanctuary where history, spirituality, and nature coexist."
  },
  {
    "title": "Colaba Causeway & South Mumbai Heritage Walk",
    "description": "Colaba Causeway, one of Mumbai’s liveliest streets, is where heritage meets modern charm. Known for its vibrant street shopping, antique stores, cafés, and colonial architecture, it’s the heartbeat of South Mumbai. Landmarks like the Taj Mahal Palace, Regal Cinema, and art galleries line the streets, while cafés like Leopold and Mondegar buzz with travelers’ conversations. A stroll down Colaba Causeway is a sensory delight — the aroma of coffee, honking taxis, and glimpses of the sea. It’s the perfect place to experience Mumbai’s cosmopolitan spirit and vintage elegance in one frame."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks, dedicated to Lord Ganesha. Built in 1801, its golden dome and intricately carved sanctum attract devotees from across India, including Bollywood celebrities and business leaders. The temple exudes divine serenity despite long queues, as chants and bells fill the air with devotion. The surrounding area buzzes with energy from flower vendors and small shops selling offerings. A visit to Siddhivinayak brings not just blessings but also a sense of peace, faith, and connection with Mumbai’s spiritual side."
  }
],



  "services": [
    {
      "name": "Wagholi to Mumbai Cab",
      "description": "Book a Wagholi to Mumbai cab for a smooth and reliable intercity ride. Our service provides comfortable AC/Non-AC options, experienced chauffeurs, and well-maintained cars. Enjoy a safe and scenic 150+ km journey via the Mumbai-Pune Expressway with flexible pickup and drop points, affordable fares, and 24x7 booking support. Ideal for family trips, airport transfers, and daily commuters."
    },
    {
      "name": "Wagholi to Mumbai Taxi Service",
      "description": "Our Wagholi to Mumbai taxi service offers convenient travel with professional drivers, clean vehicles, and on-time pickups. Whether for business, leisure, or airport transfers, choose from sedans, SUVs, and MUVs with AC/Non-AC options. Get transparent fares, real-time booking updates, and flexible travel schedules for a worry-free experience."
    },
    {
      "name": "Wagholi to Mumbai Car Hire",
      "description": "Hire a car from Wagholi to Mumbai for comfortable one-way or round trips. We offer multiple options such as Ertiga, Innova, and sedans with skilled chauffeurs ensuring safety and comfort. Enjoy flexible travel timings, doorstep pickup, online booking, and fixed-price fares for intercity convenience."
    },
    {
      "name": "Wagholi to Mumbai AC Cab",
      "description": "Travel in air-conditioned comfort from Wagholi to Mumbai with our premium AC cab service. Enjoy clean interiors, spacious seating, and cool rides ideal for family outings, corporate trips, or airport transfers. Available 24/7 with online booking and transparent pricing for a comfortable long-distance journey."
    },
    {
      "name": "Wagholi to Mumbai Non AC Cab",
      "description": "Looking for an affordable travel option? Our Non-AC Wagholi to Mumbai cab service provides comfortable and budget-friendly rides. Ideal for travelers preferring economical fares while enjoying clean, safe, and punctual journeys driven by professional chauffeurs."
    },
    {
      "name": "Wagholi to Mumbai Innova Cab",
      "description": "Hire a spacious and reliable Innova cab from Wagholi to Mumbai for a luxurious group travel experience. Perfect for family trips, weddings, or corporate outings, our Innova offers superior comfort, AC/Non-AC options, ample luggage space, and experienced drivers for a smooth ride through the expressway."
    },
    {
      "name": "Wagholi to Mumbai Ertiga Cab",
      "description": "Book an Ertiga cab from Wagholi to Mumbai for affordable and comfortable 7-seater travel. Ideal for families, small groups, or business teams. Enjoy spacious interiors, flexible pickup and drop points, online booking convenience, and professional chauffeur-driven rides."
    },
    {
      "name": "Luxury Cab Wagholi to Mumbai",
      "description": "Experience ultimate comfort with our luxury cab service from Wagholi to Mumbai. Choose from high-end cars like Innova Crysta, Fortuner, or premium sedans with plush interiors and expert chauffeurs. Best suited for VIP transfers, weddings, or corporate executives seeking a stylish and comfortable journey."
    },
    {
      "name": "Affordable Wagholi to Mumbai Cab",
      "description": "Enjoy affordable Wagholi to Mumbai cab services with AC and Non-AC options, clean cars, and courteous drivers. Get fixed fares, no hidden costs, and instant online booking. Designed for students, families, and daily commuters seeking safe and economical travel solutions."
    },
    {
      "name": "Wagholi to Mumbai Outstation Cab",
      "description": "Book an outstation cab from Wagholi to Mumbai for long-distance, family, or corporate travel. Our service includes flexible schedules, AC/Non-AC options, luggage assistance, and reliable drivers. Enjoy a seamless intercity experience with on-time pickup, comfortable seating, and secure payment options."
    },
    {
      "name": "Wagholi to Mumbai One Way Cab",
      "description": "Hire a one-way cab from Wagholi to Mumbai and pay only for your trip, not for the return. Enjoy affordable, flexible, and safe rides with professional chauffeurs. Ideal for airport transfers, business trips, and personal travel with easy online booking and transparent pricing."
    },
    {
      "name": "Wagholi to Mumbai Drop Cab",
      "description": "Our Wagholi to Mumbai drop cab service ensures comfortable one-way transfers with timely drop-offs across Mumbai. Perfect for travelers, airport passengers, or professionals commuting to Mumbai. Enjoy clean cars, skilled drivers, and affordable rates with 24x7 availability."
    },
    {
      "name": "Wagholi to Mumbai Corporate Cab",
      "description": "Corporate cab hire from Wagholi to Mumbai for business executives, meetings, and airport transfers. Enjoy punctual service, AC/Non-AC options, online invoicing, and professional drivers trained for corporate travel. Designed for comfort, reliability, and professionalism in every ride."
    },
    {
      "name": "Wagholi to Mumbai Wedding Cab",
      "description": "Elegant wedding cab service from Wagholi to Mumbai offering luxury sedans and SUVs for guests, family members, or the couple. Each cab includes AC comfort, clean interiors, experienced chauffeurs, and on-time service for smooth wedding day transportation."
    },
    {
      "name": "Wagholi to Mumbai Online Booking",
      "description": "Book your Wagholi to Mumbai cab online instantly with flexible payment options, real-time confirmations, and multiple car categories. Get AC/Non-AC, luxury, or economical options with 24x7 customer support. Enjoy seamless booking and safe intercity travel right from your doorstep."
    }
  ],
  "tableData": [
    ["Wagholi to Mumbai Cab", "Wagholi to Mumbai Taxi Service"],
    ["Wagholi to Mumbai Car Hire", "Wagholi to Mumbai AC Cab"],
    ["Wagholi to Mumbai Non AC Cab", "Wagholi to Mumbai Innova Cab"],
    ["Wagholi to Mumbai Ertiga Cab", "Luxury Cab Wagholi to Mumbai"],
    ["Affordable Wagholi to Mumbai Cab", "Wagholi to Mumbai Outstation Cab"],
    ["Wagholi to Mumbai One Way Cab", "Wagholi to Mumbai Drop Cab"],
    ["Wagholi to Mumbai Corporate Cab", "Wagholi to Mumbai Wedding Cab"],
    ["Wagholi to Mumbai Online Booking", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Wagholi to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Wagholi to Mumbai — ideal for business trips, airport transfers, or leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy clear, affordable, and one-way fares from Wagholi to Mumbai with no hidden charges, ensuring a stress-free journey."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or Tempo Travellers to match your group size, luggage, and travel preferences."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous, trained drivers are familiar with the Wagholi to Mumbai route, ensuring a safe, smooth, and punctual ride."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer pickups from anywhere in Wagholi and drop-offs at any location in Mumbai, including hotels, offices, railway stations, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability throughout your journey."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any travel-related queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Wagholi to Mumbai cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]




























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Wagholi to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Wagholi to Mumbai cab services for one-way trips, round trips, corporate travel, and group travel.',
  },
  {
    question: 'How can I book a cab from Wagholi to Mumbai with Sai Trupti Cabs?',
    answer: 'You can easily book your Wagholi to Mumbai cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking and confirmation.',
  },
  {
    question: 'What types of cabs are available from Wagholi to Mumbai?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to meet your travel needs and group size.',
  },
  {
    question: 'Are the drivers experienced for Wagholi to Mumbai trips?',
    answer: 'Yes, all our drivers are professional, courteous, and trained for long-distance travel, ensuring a safe and comfortable ride from Wagholi to Mumbai.',
  },
  {
    question: 'Can I hire a cab from Wagholi to Mumbai for family, corporate, or group trips?',
    answer: 'Certainly. Our cab services cater to family outings, corporate travel, group tours, and airport transfers between Wagholi and Mumbai.',
  },
  {
    question: 'Is the Wagholi to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Wagholi to Mumbai to suit your schedule and travel convenience.',
  },
  {
    question: 'What are the fares for Wagholi to Mumbai cab services?',
    answer: 'Cab fares from Wagholi to Mumbai start from approximately ₹1,400 for sedans and ₹1,900–₹2,800 for SUVs and larger vehicles, depending on vehicle type, distance, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Wagholi to Mumbai cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for seamless and secure transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Wagholi to Mumbai cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety protocols to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during Wagholi to Mumbai cab trips?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your Wagholi to Mumbai cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'The Wagholi to Mumbai cab I booked with Sai Trupti Cabs was excellent. The ride was comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riya Sharma',
    feedback: 'Sai Trupti Cabs made my Wagholi to Mumbai journey smooth and hassle-free. Highly recommend their service!',
    rating: 5,
  },
];














































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wagholi to Mumbai Cab",
  "image": "https://saitrupticabs.com/assets/images/wagholi-to-mumbai-cab.jpg",
  "description": "Book Wagholi to Mumbai cabs with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation trips. Reliable and affordable online cab booking 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/wagholi-to-mumbai-cab"
  }
};





  return (
    <div>
      <Helmet>
  <title>Wagholi to Mumbai Cab | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Wagholi to Mumbai cabs with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation trips. Reliable and affordable online cab booking 24x7." 
  />
  <meta 
    name="keywords" 
    content="Wagholi to Mumbai Cab, Wagholi to Mumbai Taxi Service, Wagholi to Mumbai Car Hire, Wagholi to Mumbai AC Cab, Wagholi to Mumbai Non AC Cab, Wagholi to Mumbai Innova Cab, Wagholi to Mumbai Ertiga Cab, Luxury Cab Wagholi to Mumbai, Affordable Wagholi to Mumbai Cab, Wagholi to Mumbai Outstation Cab, Wagholi to Mumbai One Way Cab, Wagholi to Mumbai Drop Cab, Wagholi to Mumbai Corporate Cab, Wagholi to Mumbai Wedding Cab, Wagholi to Mumbai Online Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Wagholitomumbaicab;